var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('ul',_vm._l((_vm.data),function(item){return _c('li',{on:{"click":function($event){return _vm.toDetails(item.noticeId)}}},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(item.noticeTitle)+" ")]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.handelDate(item.createTime)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }